import React, {useEffect, useState} from 'react';
import {logPageLoadEvents} from '@ibibo/analytics';
import {useHistory, useLocation} from 'react-router-dom';
import {makeGetRequest} from '../../store/actions/thunk';
import {useSelector, useDispatch} from 'react-redux';
import useApi from '../../hooks/useApi';

import InfoIcon from '../../stories/components/OnboardingNew/GccComponents/assets/infoIcon.png';
import OnboardingNew from '../../stories/components/OnboardingNew/OnboardingNew';
import OtpVerified from '../../stories/components/OnboardingNew/CommonComponents/OtpVerified/OtpVerified';
import BackButton from '../../stories/components/OnboardingNew/GccComponents/BackButton/BackButton';
import OtpField from '../../stories/components/OnboardingNew/GccComponents/OtpField/OtpField';
import * as S from '../../stories/components/OnboardingNew/PopUp/VerifyEmailGcc/VerifyEmailGcc.styles';
import {SUB_USER_OTP_VERIFIED} from '../../constants';

const MultiUserOtp = () => {
  const getQueryString = (field, url) => {
    var href = url ? url : window.location.href;
    var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
    var string = reg.exec(href);
    return string ? string[1] : null;
  };
  const host = `${__ENV_CONFIG__.MYPARTNER}`;
  const winSize = window.screen.width;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const subUserToken = getQueryString('subuserToken', window.location.href);

  const subUser = urlParams.get('subuser');
  const history = useHistory();
  const dispatch = useDispatch();

  const [screenName, setScreenName] = useState('INITIAL_LOADING_SCREEN');
  const {
    isLoading: isLoadingInitialData,
    data: dataInitialPageLoad,
    error: errorInitialData,
    fetchData: fetchInitialData,
    postData: postData,
    clearError: clearInitialScreenError,
    clearMultipleErrors: clearInitialScrenAllErrors,
  } = useApi();

  const {
    isLoading: isloadingOtpData,
    data: submitOtpData,
    error: submitOtpError,
    fetchData: fetchOtpData,
    postData: postSubmitOtpData,
    clearError: clearPostDataError,
  } = useApi();

  useEffect(() => {
    fetchInitialScreenData();
  }, []);

  useEffect(() => {
    if (dataInitialPageLoad?.is_gcc_user) {
      logPageLoadEvents('platform:subUserOnboarding|mypartner', {
        eVar15: 'platform:subUserOnboarding|mypartner',
        prop54: 'myp_sub_VerifyEmailShown',
      });
    } else {
      logPageLoadEvents('platform:subUserOnboarding|mypartner', {
        eVar15: 'platform:subUserOnboarding|mypartner',
        prop54: 'myp_sub_VerifyNoShown',
      });
    }
    if (dataInitialPageLoad?.screen === 'SUBUSER_OTP_VERIFICATION') {
      setScreenName('SUBUSER_OTP_VERIFICATION');
    }
    if (dataInitialPageLoad?.screen === 'SUBUSER_OTP_VERIFIED') {
      setScreenName('SUBUSER_OTP_VERIFIED');
    } else if (dataInitialPageLoad?.screen === 'SUBUSER_CREATE_ACCOUNT') {
      window.open(dataInitialPageLoad?.redirectUrl, '_self');
    }
  }, [dataInitialPageLoad]);

  useEffect(() => {
    if (submitOtpData?.screen === 'SUBUSER_OTP_VERIFIED') {
      setScreenName('SUBUSER_OTP_VERIFIED');
      if (dataInitialPageLoad?.is_gcc_user) {
        logPageLoadEvents('platform:subUserOnboarding|mypartner', {
          eVar15: 'platform:subUserOnboarding|mypartner',
          prop54: 'myp_sub_EmailVerified',
        });
      } else {
        logPageLoadEvents('platform:subUserOnboarding|mypartner', {
          eVar15: 'platform:subUserOnboarding|mypartner',
          prop54: 'myp_sub_MobileVerified',
        });
      }
    } else if (submitOtpData?.screen === 'SUBUSER_CREATE_ACCOUNT') {
      window.open(submitOtpData?.responseRedirectUrl, '_self');
    }
  }, [submitOtpData]);

  const fetchInitialScreenData = () => {
    const url = `${host}/agents/subuser-verification?token=${encodeURI(subUserToken)}`;
    fetchInitialData(url);
    clearInitialScrenAllErrors(clearInitialScreenError, clearPostDataError);
  };

  const handleChange = otp => {
    if (otp.length === 6) {
      //history.push(`${SUB_USER_OTP_VERIFIED}`);
      const url = `${host}/agents/subuser-verification/`;
      const data = {
        otp: otp,
        token: subUserToken,
      };
      postSubmitOtpData(url, data);
    }
  };

  useEffect(() => {
    if (errorInitialData?.message) {
      setScreenName('ERROR_INITIAL_SCREEN');
      logPageLoadEvents('platform:subUserOnboarding|mypartner', {
        eVar15: 'platform:subUserOnboarding|mypartner',
        eVar22: errorInitialData?.message,
      });
    }
  }, [errorInitialData, isLoadingInitialData]);

  useEffect(() => {
    logPageLoadEvents('platform:subUserOnboarding|mypartner', {
      eVar15: 'platform:subUserOnboarding|mypartner',
      eVar22: 'myp_sub_OTPError',
    });
  }, [submitOtpError]);

  return (
    <OnboardingNew step={1}>
      {screenName === 'INITIAL_LOADING_SCREEN' ? (
        <></>
      ) : screenName === 'ERROR_INITIAL_SCREEN' ? (
        <OtpVerified
          heading={errorInitialData?.message}
          isVerificationSuccessFull={false}
          headingIcon={true}
          height={'280px'}
        />
      ) : screenName === 'SUBUSER_OTP_VERIFICATION' ? (
        <S.VrfyEmail>
          {true && (
            <S.VrfyEmailHdr>
              {winSize <= 767 ? <BackButton text="CLOSE" arrow={true} /> : <></>}
            </S.VrfyEmailHdr>
          )}
          <S.Heading>
            <span>
              <img src={InfoIcon} alt="" />
            </span>
            Verify {dataInitialPageLoad?.is_gcc_user ? 'email' : 'phone number'} using OTP
          </S.Heading>
          <S.SubHeading>
            We've sent a 6 digit code. Please check your{' '}
            {dataInitialPageLoad?.is_gcc_user ? 'email' : 'phone number'}:{' '}
            <span>{dataInitialPageLoad?.primary_id}</span> and enter here to complete the
            verification
          </S.SubHeading>
          <S.Content>
            <OtpField
              labelText="Enter OTP"
              resendOtp="Resend OTP"
              onChange={handleChange}
              showLoader={isloadingOtpData}
              resendOtpCaller={fetchInitialScreenData}
              //disableResendOtp={disableResendOtp}
            />
          </S.Content>
          {submitOtpError?.message && <S.ErrorMsg>{submitOtpError?.message}</S.ErrorMsg>}
        </S.VrfyEmail>
      ) : screenName === 'SUBUSER_OTP_VERIFIED' ? (
        <OtpVerified
          heading={submitOtpData?.heading}
          subHeading={submitOtpData?.subHeading}
          isVerificationSuccessFull={true}
          message={submitOtpData?.message}
          headingIcon={true}
          responseRedirectUrl={submitOtpData?.responseRedirectUrl}
          height={300}
        />
      ) : (
        <></>
      )}
    </OnboardingNew>
  );
};

export default MultiUserOtp;
